import { atlasRoutes } from "@/app/router/routes";
import { Button } from "@/components/button";
import { Table } from "@/components/table/table";
import { TextFieldRow } from "@/components/table/text-field-row";
import { UuidFieldRow } from "@/components/table/uuid-field-row";
import { UploadedImage } from "@/components/uploaded-image";
import { api } from "@/modules/api";
import { ColumnDef } from "@tanstack/react-table";
import { useQuery } from "@tanstack/react-query";
import { FC, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import styled from "@emotion/styled";
import { StaffMemberBadgeSchema } from "@/domains/openapi/types";

export const AdminMemberBadgesRootPage: FC = () => {
  const navigate = useNavigate();
  const [staffMemberId, setStaffMemberId] = useState("");
  const pageSize = 50;

  const result = useQuery({
    queryKey: ["member-badges", staffMemberId],
    queryFn: () =>
      api.post("/internal/v1/staff/member-badges/search", {
        body: { staff_member_id: staffMemberId || undefined, limit: pageSize },
      }),
  });

  const data = result.data?.data?.results ?? [];

  const columns = useMemo<ColumnDef<StaffMemberBadgeSchema>[]>(
    () => [
      {
        header: "Image",
        cell: ({ row }) => (
          <UploadedImage
            uploadedFileId={row.original.staff_badge.image_uploaded_file_id}
            size={32}
          />
        ),
      },
      {
        header: "ID",
        cell: ({ row }) => <UuidFieldRow id={row.original.id} />,
      },
      {
        header: "Member",
        cell: ({ row }) => <UuidFieldRow id={row.original.staff_member_id} />,
      },
      {
        header: "Badge",
        cell: ({ row }) => <UuidFieldRow id={row.original.staff_badge_id} />,
      },
      {
        header: "Context",
        cell: ({ row }) => <TextFieldRow value={row.original.context} />,
      },
      {
        header: "View",
        cell: ({ row }) => (
          <Button
            variant="outline"
            size="1"
            onClick={() =>
              navigate(
                atlasRoutes.adminMemberBadgesView({ params: { memberBadgeId: row.original.id } })
                  .path
              )
            }
          >
            View
          </Button>
        ),
      },
    ],
    [navigate]
  );

  return (
    <Container>
      <h1>Member Badges</h1>
      <div>
        <input
          placeholder="Filter by staff member ID"
          value={staffMemberId}
          onChange={e => setStaffMemberId(e.target.value)}
        />
        <Button onClick={() => navigate(atlasRoutes.adminMemberBadgesCreate({}).path)}>
          Award Badge
        </Button>
      </div>
      <br />
      <Table data={data} columns={columns} pageSize={pageSize} />
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
`;
